import React from 'react';
import PropTypes from 'prop-types';

export const GoogleMapsContext = React.createContext(null);

export function GoogleMapsContextProvider({ children }) {
    const [loaded, setLoaded] = React.useState(false);
    const [error, setError] = React.useState(null);

    window.onGMapsLoaded = () => {
        setLoaded(true);
    };

    React.useEffect(() => {
        let script_dom = document.querySelector('script.gmaps-willy');
        if (loaded || script_dom) {
            // The script is already here & loaded
            setLoaded(true);
            return;
        }

        let script = document.createElement('script');
        script.setAttribute('defer', true);
        script.setAttribute('async', true);
        script.classList.add('gmaps-willy');
        script.src = `https://maps.googleapis.com/maps/api/js?key=` + window.weezConfig.googleAutocomplete + `&libraries=places&callback=onGMapsLoaded`;
        script.onerror = () => setError(true);
        document.head.appendChild(script);
    }, []);

    return (
        <GoogleMapsContext.Provider
            value={{
                google: window.google,
                loaded,
                error
            }}
        >
            {children}
        </GoogleMapsContext.Provider>
    );
}

GoogleMapsContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default function useGoogleMapsContext() {
    const context = React.useContext(GoogleMapsContext);

    const { google, loaded, error } = context;

    return [google, error, loaded];
}
